import { queryChannelVideos } from '@wix/ambassador-video-v3-channel-video/http';
export const fetchChannelVideos = async (httpClient, channelId) => {
  try {
    let cursor;
    const allChannelVideos = [];
    const LIMIT = 25;
    do {
      var _paging$cursors;
      const {
        data: {
          videos,
          paging
        }
      } = await httpClient.request(queryChannelVideos({
        channelId,
        query: {
          cursorPaging: {
            cursor,
            limit: LIMIT
          }
        }
      }));
      allChannelVideos.push(...(videos ?? []));
      cursor = paging == null || (_paging$cursors = paging.cursors) == null ? void 0 : _paging$cursors.next;
    } while (cursor);
    return allChannelVideos;
  } catch (e) {
    return [];
  }
};
//# sourceMappingURL=fetch-channel-videos.js.map